import { compose, hoistStatics, withState, lifecycle, withHandlers, withPropsOnChange, withProps } from 'recompose';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import Tickets from './Tickets';
import WithLoading from '../../../components/WithLoading';
import fh from '../../../helpers/form.helper';
import TicketService from '../../../services/ticket.service';
import ModuleService from '../../../services/module.service';
import { settingsActions } from '../../../reducers/settings';

const defaultCriteria = {
  page: 0,
  limit: 5,
};

const goToPage = props => async (nextPage) => {
  const { criteria, setCriteria, setData, defaultLang, setCount, setIsEmpty } = props;
  const page = nextPage > -1 ? nextPage : 0;
  const pageData = await TicketService.getData({ ...criteria, page, lang: defaultLang });
  setData(pageData.data);
  setCount(pageData.count);
  const filteredCriteria = Object.keys(criteria).filter(key => criteria[key]);
  if (!filteredCriteria.includes('search')) {
    if (!pageData.data.length) {
      setIsEmpty({ status: 1 });
    } else {
      setIsEmpty({ status: 0 });
    }
  } else if (!pageData.data.length) {
    setIsEmpty({ status: 2 });
  } else {
    setIsEmpty({ status: 0 });
  }
  setCriteria({ ...criteria, page });
};

const showItem = props => async (e, article) => {
  e.preventDefault();
  const { history } = props;
  history.push(`/ticket/${article.id}`);
};


const callbackToSetSearch = props => async (value) => {
  const { history } = props;
  history.push('/ticket');
  await goToPage({ ...props, criteria: { ...props.criteria, search: value } })(0);
};

const mapStateToProps = state => ({
  defaultLang: state.settings.defaultLanguage,
  modulesSettings: state.modules.modulesSettings,
});


const addNew = props => async (e) => {
  e.preventDefault();
  if (props.location.pathname !== '/ticket/new') {
    await goToPage({ ...props, criteria: { ...props.criteria, search: '' } })(0);
    props.history.push('/ticket/new');
  }
};

const addNewTicketEmpty = props => (e) => {
  e.preventDefault();
  if (props.location.pathname !== '/ticket/new') {
    props.setIsEmpty({ status: 2 });
    props.history.push('/ticket/new');
  }
};

const mapDispatchToProps = {
  updateSettings: settingsActions.updateSettings,
};

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withState('isLoading', 'setIsLoading', true),
  withState('criteria', 'setCriteria', defaultCriteria),
  withState('formData', 'setFormData', {}),
  withState('count', 'setCount', 0),
  withState('data', 'setData', []),
  withState('loadTicket', 'setLoadTicket', false),
  withState('updated', 'setUpdated', null),
  withState('addNewTicket', 'setAddNewTicket', false),
  withState('isEmpty', 'setIsEmpty', { status: 0 }),
  translate('portal'),
  lifecycle({
    async componentDidMount() {
      const { setIsLoading, updateSettings } = this.props;
      updateSettings({ hasLoadedPage: false });
      await goToPage(this.props)(0);
      setIsLoading(false);
      updateSettings({ hasLoadedPage: true });
    },
  }),
  withProps(props => ({
    moduleTitle: props.modulesSettings[ModuleService.TYPE_TICKETS].title || props.t('Ticket system'),
    backgroundColor: props.modulesSettings[ModuleService.TYPE_TICKETS].color ?
      props.modulesSettings[ModuleService.TYPE_TICKETS].color : props.modulesSettings[ModuleService.TYPE_TICKETS].default_color,
    backgroundCover: props.modulesSettings[ModuleService.TYPE_TICKETS].cover,
    enableCoverColor: props.modulesSettings[ModuleService.TYPE_TICKETS].enable_cover_color,
  })),
  withPropsOnChange(['updated'], (props) => {
    if (!props.isLoading && props.updated && Object.keys(props.updated).length !== 0) {
      if (props.updated.page !== undefined)goToPage(props)(props.updated.page);
      else goToPage(props)(props.criteria.page);
      props.setUpdated(null);
    }
  }),
  withHandlers({
    addNew,
    showItem,
    goToPage,
    addNewTicketEmpty,
    callbackToSetSearch,
    onChangeMl: fh.onChangeFormDataMlElement,
  }),
);
export default withRouter(hoistStatics(enhance)(WithLoading(Tickets)));



// WEBPACK FOOTER //
// ./src/views/modules/ticket/index.js